<template>
  <v-sheet>
    <v-container>
      <h1 class="display-2 mb-5 font-weight-bold primary-color">Details</h1>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="text-left font-weight-bold">
                Tanggal 
              </td>
              <td class="text-left">
                {{convertDate(details.cash_receipt.date)}}
              </td>
            </tr>
            <tr>
              <td class="text-left font-weight-bold">
                Jumlah 
              </td>
              <td class="text-left">
                Rp.{{convert(details.cash_receipt.amount)}},00
              </td>
            </tr>
            <tr>
              <td class="text-left font-weight-bold">
                Tipe 
              </td>
              <td class="text-left text-uppercase">
                {{details.cash_receipt.payment_type}}
              </td>
            </tr>
            <tr>
              <td class="text-left font-weight-bold">
                Diminta Oleh 
              </td>
              <td class="text-left">
                {{details.sender.name}}
              </td>
            </tr>
            <tr>
              <td class="text-left font-weight-bold">
                Ditujukan Kepada 
              </td>
              <td class="text-left">
                {{details.user.name}}
              </td>
            </tr>
            <tr>
              <td class="text-left font-weight-bold">
                Detail 
              </td>
              <td class="text-left">
                <p class="mb-0">{{details.cash_receipt.details}}</p>
              </td>
            </tr>
            <tr>
              <td class="text-left font-weight-bold">
                Status 
              </td>
              <td class="text-left">
                  <v-chip
                    small
                    class="mt-2"
                    :class="details.status == 0 ? 'fade-in' : ''"
                    :color="details.status == 0 ? 'red' : (details.status == 1? 'green' : 'black')"
                    text-color="white"
                  >
                    {{details.status == 0 ? 'Need Approval' : (details.status == 1? 'Approved' : 'Ditolak')}}
                  </v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div v-if="user.role_id <= 3 && details.status == 0 && details.user_id === user.id">
        <v-btn @click="approve(details.id)" class="mt-6 primary-background" dark x-large block>Approve</v-btn>
        <v-btn @click="disapprove(details.id)" class="mt-6" color="red" dark x-large block>Disapprove</v-btn>
      </div>
      <div v-if="user.role_id <= 3 && details.status != 0 && details.user_id === user.id">
        <v-btn @click="deleteReceipt(details.id)" class="mt-6" color="red" dark x-large block>Delete</v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import numeral from 'numeral'
export default {
  computed : {
    ...mapGetters({
      details : 'Forms/details',
      user : 'Auth/user',
    })
  },
  methods : {
    ...mapActions({
      approve : 'Forms/approve',
      disapprove : 'Forms/disapprove',
      deleteReceipt : 'Forms/deleteReceipt'
    }),
    convert(number){
      return numeral(number).format('0,0')
    },
    convertDate (date) {
      var date_actual = new Date(date)
      date_actual = date_actual.getDate() + ' ' + this.getMonth(date_actual.getMonth()) + ' ' + date_actual.getFullYear()
      return  date_actual
    },
    getMonth (month) {
      month++
      switch (month) {
        case 1:
          return "Januari";
          break;
        case 2:
          return "Februari";
          break;
        case 3:
          return "Maret";
          break;
        case 4:
          return "April";
          break;
        case 5:
          return "Mei";
          break;
        case 6:
          return "Juni";
          break;
        case 7:
          return "Juli";
          break;
        case 8:
          return "Agustus";
          break;
        case 9:
          return "September";
          break;
        case 10:
          return "Oktober";
          break;
        case 11:
          return "November";
          break;
        case 12:
          return "Desember";
          break;
        default:
          return 
          break;
      }
    }
  }
}
</script>

<style>

</style>